<ion-modal
  [isOpen]="isOpen"
  (didDismiss)="onClose()"
  [breakpoints]="[0, 0.5, 0.65, 0.75, 0.95]"
  [initialBreakpoint]="initialBreakpoint"
  handleBehavior="cycle"
  class="product-details-modal"
  (ionModalDidPresent)="initializeSwiper()"
>
  @if (product) {
  <ion-content class="ion-padding">
    <div class="container">
      <div class="card" [ngClass]="{ 'restricted-card': isRestricted }">
        @if (product?.pay_at_door) {
        <div class="ribbon-wrapper">
          <div class="ribbon">
            {{ "products.pay_at_door_label" | translate }}
          </div>
        </div>
        } @if (productImages.length) {
        <div class="swiper-container-wrapper">
          <swiper-container
            slides-per-view="1"
            pagination="true"
            loop="true"
            class="product-swiper"
            [attr.data-initialized]="swiperInitialized"
          >
            @for (image of productImages; track trackByImage($index, image)) {
            <swiper-slide>
              <img
                appImageZoom
                [src]="imageError ? 'assets/images/default-image.png' : image"
                alt="Imagen del producto"
                class="image"
                (error)="imageError = true"
                (load)="onImageLoad()"
              />
            </swiper-slide>
            }
          </swiper-container>
        </div>
        }
        <p class="product-title">{{ product.name }}</p>
        @if (!isProductExclusivePromotional) {
        <p class="text-line">
          <span class="label">
            {{ "detail-product.category" | translate }}
          </span>
          @if (product.category?.name) {
          {{ product.category.name }}
          } @else {
          {{ product.category }}
          }
        </p>
        }
        <p class="text-line">
          <span class="label">
            {{ "products.tolerance" | translate }}
          </span>
          {{ toleranceText }}
        </p>
        @if (formattedCommission) {
        <p class="text-line">
          <span class="label">
            {{ "detail-product.comission" | translate }}
          </span>
          {{ formattedCommission }}
        </p>
        } @if (isProductExclusivePromotional) {
        <div class="payment-method">
          <img
            src="assets/icons/method-payment-icon.svg"
            alt="Método de pago"
            class="ticket-icon"
          />
          {{
            translatedPaymentMethods ||
              ("products.direct_sale_label" | translate)
          }}
        </div>
        } @if (showProgressBar) {
        <app-product-progress-bar
          [product]="product"
          [totalProductsSoldType]="totalProductsSoldType"
          [isInsideCard]="false"
        />
        }
        <p class="price-amount">{{ product.price | arsCurrency }}</p>
        <hr />
        <p class="description-text">
          {{ product.description }}
        </p>
        <p class="description-text">
          {{
            "detail-product.valid_from_to"
              | translate
                : {
                    from: (product.initial_date | shortDateTime),
                    to: (product.finish_date | shortDateTime)
                  }
          }}
        </p>
        @if (showSalePeriod) {
        <p class="description-text">
          {{
            "detail-product.sale_from_to"
              | translate
                : {
                    from: (product.sale_initial_date | shortDateTime),
                    to: (product.sale_finish_date | shortDateTime)
                  }
          }}
        </p>
        } @if (showMinAge) {
        <p class="description-text">
          {{
            "detail-product.min_age_text" | translate : { age: product.min_age }
          }}
        </p>
        } @if (product?.sale_date_message) {
        <p class="description-text time-message">
          <ion-icon name="time-outline" class="time-icon" />
          {{ product.sale_date_message }}
        </p>
        }
      </div>
    </div>
  </ion-content>
  }
</ion-modal>
